export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  // ===== 通用 =====
  'common.yes': '是',
  'common.no': '否',
  'common.action': '操作',
  'common.delete': '删除',
  'common.deleted': '已删除',
  'common.deleteFailed': '删除失败',
  'common.refresh': '刷新',
  'common.create': '新建',
  'common.createSuccess': '创建成功',
  'common.edit': '编辑',
  'common.save': '保存',
  'common.saveSuccess': '保存成功',
  'common.operationFailed': '操作失败',
  'common.optional': '可选',

  // ===== AI 模型配置 =====
  'pages.system.aiModels.title': 'AI 模型配置',
  'pages.system.aiModels.table.id': 'ID',
  'pages.system.aiModels.table.name': '名称',
  'pages.system.aiModels.table.publicId': '对外模型 ID',
  'pages.system.aiModels.table.modelId': '供应商模型 ID',
  'pages.system.aiModels.table.endpointUrl': '请求地址',
  'pages.system.aiModels.table.apiKey': 'API Key',
  'pages.system.aiModels.apiKey.empty': '未配置',
  'pages.system.aiModels.table.reasoningMode': '推理模式',
  'pages.system.aiModels.table.enabled': '启用',
  'pages.system.aiModels.table.updatedAt': '更新时间',
  'pages.system.aiModels.reasoningMode.none': '无',
  'pages.system.aiModels.reasoningMode.optional': '可选',
  'pages.system.aiModels.reasoningMode.required': '必需',
  'pages.system.aiModels.confirmDelete': '确认删除该模型配置？',
  'pages.system.aiModels.note':
    '说明：该列表来自 backend-worker 的 D1（/api/system/ai/models），用于维护可用 AI 模型与转发配置；对外下发的模型 ID 为自动生成的 UUID。',
  'pages.system.aiModels.modal.editTitle': '编辑模型',
  'pages.system.aiModels.modal.createTitle': '新建模型',
  'pages.system.aiModels.fetchAvailable': '获取可用模型',
  'pages.system.aiModels.fetchAvailableSuccess': '已获取可用模型列表',
  'pages.system.aiModels.fetchAvailableFailed':
    '获取可用模型失败，请检查后端 AI 配置',
  'pages.system.aiModels.form.name.label': '显示名称',
  'pages.system.aiModels.form.name.placeholder': '例如：OpenAI GPT-4o mini',
  'pages.system.aiModels.form.publicId.label': '对外模型 ID',
  'pages.system.aiModels.form.publicId.extra':
    '创建后自动生成，用于客户端请求。',
  'pages.system.aiModels.form.publicId.placeholder': '创建后自动生成',
  'pages.system.aiModels.form.modelId.label': '供应商模型 ID',
  'pages.system.aiModels.form.reasoningMode.label': '推理模式',
  'pages.system.aiModels.form.modelId.placeholder': '例如：gpt-4o-mini',
  'pages.system.aiModels.form.modelId.extra':
    '你也可以从“获取可用模型”拉取的列表中选择一个。',
  'pages.system.aiModels.form.modelId.extraEmpty':
    '可手动填写；如已配置后端 AI_OPENAI_*，可点击“获取可用模型”辅助选择。',
  'pages.system.aiModels.form.endpointUrl.label': '请求地址',
  'pages.system.aiModels.form.endpointUrl.extra':
    '填写供应商的 Chat Completions 请求地址，或其基础地址（将自动拼接 /chat/completions）。',
  'pages.system.aiModels.form.endpointUrl.placeholder':
    '例如：https://api.openai.com/v1/chat/completions',
  'pages.system.aiModels.form.apiKey.label': 'API Key',
  'pages.system.aiModels.form.apiKey.placeholder': '例如：sk-***',
  'pages.system.aiModels.form.enabled.label': '启用',

  // ===== 系统更新 =====
  'pages.system.update.title': '系统更新',
  'pages.system.update.table.id': 'ID',
  'pages.system.update.table.appId': '应用',
  'pages.system.update.table.version': '版本',
  'pages.system.update.table.force': '强制',
  'pages.system.update.table.downloadUrl': '下载链接',
  'pages.system.update.table.createdAt': '创建时间',
  'pages.system.update.confirmDelete': '确认删除该更新？',
  'pages.system.update.note':
    '说明：数据来自 backend-worker 的 D1（/api/system/update/list）。',
  'pages.system.update.modal.createTitle': '新建更新',
  'pages.system.update.createFailedInvalidJson':
    '创建失败（logsJson 需为合法 JSON）',
  'pages.system.update.form.appId.label': '应用 ID',
  'pages.system.update.form.appId.placeholder': '例如: skydimo',
  'pages.system.update.form.version.label': '版本号',
  'pages.system.update.form.version.placeholder': '例如: 1.2.3',
  'pages.system.update.form.commitId.label': 'Commit ID',
  'pages.system.update.form.downloadUrl.label': '下载链接',
  'pages.system.update.form.createdAt.label': '创建时间（可用于定时上线）',
  'pages.system.update.form.createdAt.tooltip':
    '留空则由后端使用当前时间；若设置为未来时间，则 /api/update/check 与 /api/latest 在到达该时间前不会返回该更新。',
  'pages.system.update.form.force.label': '强制更新',
  'pages.system.update.form.logsJson.label': '更新日志（JSON）',
  'pages.system.update.form.logsJson.tooltip':
    '后端字段为 Record<string, string>，如 {"zh-CN":"...","en-US":"..."}',

  // ===== 博客管理 =====
  'pages.system.blog.title': '博客管理',
  'pages.system.blog.table.id': 'ID',
  'pages.system.blog.table.uuid': 'UUID',
  'pages.system.blog.table.published': '已发布',
  'pages.system.blog.table.coverUrl': '封面链接',
  'pages.system.blog.table.createdAt': '创建时间',
  'pages.system.blog.table.updatedAt': '更新时间',
  'pages.system.blog.confirmDelete': '确认删除该文章？',
  'pages.system.blog.note':
    '说明：数据来自 backend-worker 的 D1（/api/system/blog/list）。',
  'pages.system.blog.modal.createTitle': '新建博客',
  'pages.system.blog.createFailedInvalidJson':
    '创建失败（titles/contents 需为合法 JSON）',
  'pages.system.blog.form.uuid.label': 'UUID',
  'pages.system.blog.form.coverUrl.label': '封面链接',
  'pages.system.blog.form.published.label': '是否发布',
  'pages.system.blog.form.createdAt.label': '创建时间（可用于定时发布）',
  'pages.system.blog.form.createdAt.tooltip':
    '留空则由后端使用当前时间；若设置为未来时间，则公开接口 /api/blog/list、/api/blog/detail 在到达该时间前不会返回该文章。',
  'pages.system.blog.form.titlesJson.label': '标题（JSON）',
  'pages.system.blog.form.contentsJson.label': '内容（JSON）',
};
